import * as React from "react";
import { Paragraph } from "@project-stories/elements/Paragraph/Paragraph";
import Headings from "@project-stories/elements/Headings/Headings";
import useColoredTextParser from "@project-stories/../hooks/useColoredTextParser"; // adjust path as needed

export const TextHeading = ({ settings }) => {
    const headingText = settings.title;
    const renderFormattedTitle = useColoredTextParser({
        title: headingText,
        accentTitleParts: settings.accent_title_parts,
        accentColor: settings.accent_color,
        seoStyle: settings?.seo_title_font_type,
        headerStyle: settings.heading_type || 'h3',
        classes: '',
        HeadingsComponent: Headings, // fallback to Paragraph below
    });

    return (
        <div>
            {headingText && (renderFormattedTitle() ||
                <Paragraph 
                    text={headingText} 
                    type={settings.heading_type || 'h3'} 
                    seo_type={settings?.seo_title_font_type}
                />
            )}
        </div>
    );
};

export default TextHeading;